module.exports = __webpack_public_path__ + "static/media/ui-kit.8cd4248b.jpg";